import { StringToBooleanPipe } from './string-to-boolean.pipe';

export const STRING_TO_BOOLEAN_PIPE_DECLARATIONS = [StringToBooleanPipe];

export * from './string-to-boolean.pipe';
